import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { UserRoutingModule } from './user-routing.module';
import { LoginComponent } from '../../login/login.component';
import { UserService } from '../../services/user.service';
import { ShareModule } from '../share/share.module';
import { TranslateModule } from '@ngx-translate/core';
import { CountdownComponent } from 'ngx-countdown';

@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    HttpClientModule,
    ShareModule,
    TranslateModule.forChild(),
    CountdownComponent
  ],
  declarations: [LoginComponent],
  providers: [UserService],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class UserModule { }
